import session from './session';
import axios from 'axios';
import ErrorMessages from './error-messages';

const settings = {
    getValue: (key, defaultVal=null) => {
        var user = session.getUserName();
        if (user) {
            var settings = JSON.parse(localStorage.getItem('settings_minisite'));
            if (settings && (user in settings) && (key in settings[user])) {
                return settings[user][key];
            }
        }
        return defaultVal;
    },
    setValue: (key, val) => {
        var user = session.getUserName();
        if (user) {
            var settings = JSON.parse(localStorage.getItem('settings_minisite'));
            if (!settings) {
                settings = {};
            }
            if (!settings[user]) {
                settings[user] = {};
            }
            settings[user][key] = val;
            localStorage.setItem('settings_minisite', JSON.stringify(settings));
        }
    }
};

export default settings;